import { render, staticRenderFns } from "./PendingDeliveryDetails.vue?vue&type=template&id=5a627f04&scoped=true"
import script from "./PendingDeliveryDetails.vue?vue&type=script&lang=js"
export * from "./PendingDeliveryDetails.vue?vue&type=script&lang=js"
import style0 from "./PendingDeliveryDetails.vue?vue&type=style&index=0&id=5a627f04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a627f04",
  null
  
)

export default component.exports